module.exports = __webpack_public_path__ + "static/media/toilet96.31890285.svg";